module.exports = __webpack_public_path__ + "static/media/microbio.0557bc2b.png";